function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable no-unused-vars */
import React from '../../_snowpack/pkg/react.js';
import { observer } from '../../_snowpack/pkg/mobx-react-lite.js';
import DatePicker from '../../_snowpack/pkg/react-datepicker.js';
import { Controller, useForm } from '../../_snowpack/pkg/react-hook-form.js';
import Select from '../../_snowpack/pkg/react-select.js';
import { useStore } from '../stores/index.js';
import { jsx as __cssprop } from "../../_snowpack/pkg/@emotion/react.js";
const MyDate = ({
  name,
  control
}) => __cssprop(Controller, {
  name: name,
  control: control,
  render: ({
    field
  }) => __cssprop(DatePicker, {
    placeholderText: "N/A",
    selected: field.value,
    onChange: date => field.onChange(date),
    className: "form-control"
    // Only pass necessary props, not {...field}
    ,
    onBlur: field.onBlur,
    ref: field.ref
  })
});
const MySelect = ({
  name,
  control,
  options,
  isMulti,
  placeholder
}) => __cssprop(Controller, {
  name: name,
  control: control,
  render: ({
    field
  }) => __cssprop(Select, _extends({}, field, {
    options: options,
    isMulti: isMulti,
    closeMenuOnSelect: !isMulti,
    placeholder: placeholder,
    isClearable: true
  }))
});
const MyInput = ({
  register,
  name,
  placeholder
}) => __cssprop("input", _extends({}, register(name), {
  type: "text",
  className: "form-control",
  placeholder: placeholder
}));
export default observer(function Fiter() {
  const store = useStore();
  const {
    control,
    register,
    handleSubmit
  } = useForm();
  const onSubmit = data => {
    let formData = {
      ...data,
      deliveryMethod: data.deliveryMethod?.value,
      status: data.status?.value,
      account: data.account?.value,
      tags: data.tags?.map(item => item.value)
    };
    store.setFilter(formData);
  };
  return __cssprop("div", {
    id: "ts-form-filter",
    className: "thermal-form"
  }, __cssprop("form", {
    onSubmit: handleSubmit(onSubmit)
  }, __cssprop("div", {
    css: {
      "display": "flex",
      "> :not([hidden]) ~ :not([hidden])": {
        "--tw-space-x-reverse": 0,
        "marginRight": "calc(0.5rem * var(--tw-space-x-reverse))",
        "marginLeft": "calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))"
      },
      "alignItems": "flex-end"
    }
  }, __cssprop("div", {
    css: {
      "width": "16.666667%"
    }
  }, __cssprop("label", null, "Order #"), __cssprop(MyInput, {
    name: "orderNumber",
    register: register,
    placeholder: "Order #"
  })), __cssprop("div", {
    css: {
      "width": "16.666667%"
    }
  }, __cssprop("label", null, "Account"), __cssprop(MySelect, {
    name: "account",
    control: control,
    options: store.accounts,
    placeholder: "Account"
  })), __cssprop("div", {
    css: {
      "width": "16.666667%"
    }
  }, __cssprop("label", null, "Order Status"), __cssprop(MySelect, {
    name: "status",
    control: control,
    options: store.orderStatuses,
    placeholder: "Order Status"
  })), __cssprop("div", {
    css: {
      "width": "25%"
    }
  }, __cssprop("label", null, "Order Date"), __cssprop("div", {
    css: {
      "display": "flex",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(209, 213, 219, var(--tw-bg-opacity))",
      "borderRadius": "0.375rem"
    }
  }, __cssprop(MyDate, {
    name: "orderDateStart",
    control: control
  }), __cssprop("div", {
    css: {
      "paddingLeft": "1rem",
      "paddingRight": "1rem",
      "alignSelf": "center"
    }
  }, "to"), __cssprop(MyDate, {
    name: "orderDateEnd",
    control: control
  }))), __cssprop("div", {
    css: {
      "width": "25%"
    }
  }, __cssprop("label", null, "Ship By"), __cssprop("div", {
    css: {
      "display": "flex",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(209, 213, 219, var(--tw-bg-opacity))",
      "borderRadius": "0.375rem"
    }
  }, __cssprop(MyDate, {
    name: "shipByDateStart",
    control: control
  }), __cssprop("div", {
    css: {
      "paddingLeft": "1rem",
      "paddingRight": "1rem",
      "alignSelf": "center"
    }
  }, "to"), __cssprop(MyDate, {
    name: "shipByDateEnd",
    control: control
  })))), __cssprop("div", {
    css: {
      "display": "flex",
      "> :not([hidden]) ~ :not([hidden])": {
        "--tw-space-x-reverse": 0,
        "marginRight": "calc(0.5rem * var(--tw-space-x-reverse))",
        "marginLeft": "calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))"
      },
      "marginTop": "0.75rem",
      "alignItems": "flex-end"
    }
  }, __cssprop("div", {
    css: {
      "width": "16.666667%"
    }
  }, __cssprop("label", null, "Delivery Method"), __cssprop(MySelect, {
    name: "deliveryMethod",
    control: control,
    options: store.deliveryMethods,
    placeholder: "Delivery Method"
  })), __cssprop("div", {
    css: {
      "width": "16.666667%"
    }
  }, __cssprop("label", null, "Tracking Number"), __cssprop(MyInput, {
    name: "trackingNumber",
    register: register,
    placeholder: "Tracking Number"
  })), __cssprop("div", {
    css: {
      "width": "41.666667%"
    }
  }, __cssprop("label", null, "Tags"), __cssprop(MySelect, {
    name: "tags",
    isMulti: true,
    control: control,
    options: store.tags,
    placeholder: "Enter any problem orders"
  })), __cssprop("div", {
    css: {
      "width": "8.333333%",
      "alignSelf": "flex-end",
      "paddingBottom": "0.25rem"
    }
  }, __cssprop("button", {
    type: "submit",
    className: "btn btn-primary"
  }, "Show")))));
});